module.exports = __webpack_public_path__ + "img/hodl.a05f6921.svg";